/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { useParams } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { generatePayment } from "../utils/functions";
import Loader from "../components/Loader";
import TopBar from "../components/TopBar";
import { isMobile } from "../utils/functions";
import { MDBSpinner } from "mdb-react-ui-kit";
const Home = () => {
  const { company_code, order_id } = useParams();

  // Renderiza el componente de clase Home y pasa los parámetros de la URL como props
  return <Class company_code={company_code} order_id={order_id} />;
};

class Class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      order_id: "",
      company_code: "",
      qr_id: "",
      isValid: true,
      loading: true,
      hideOrder: false,
    };
  }

  changeHandler = async (event) => {
    this.setState({
      ...this.state,
      [event.target.name]: event.target.value.trim(),
    });
  };

  redirectToLogin = async (event) => {
    if (event.key === "Enter") {
      await this.validateOrder();
    }
  };
  redirectToLoginB = async (event) => {
    if (this.state.order_id.length >= 5) {
      await this.validateOrder();
    } else {
      this.setState({
        errorMessage: "Ingrese una reserva válida",
      });
    }
  };
  validateOrder = async (event) => {
    this.setState({
      hideOrder: true,
      errorMessage: "",
    });
    if (this.state.order_id.length >= 5) {
      let resp = await generatePayment(
        this.state.company_code,
        this.state.order_id
      );
      console.log("goB", resp);
      if (resp.status) {
        this.setState({
          redirect: true,
          qr_id: resp.qr_id,
        });
      } else {
        console.log(resp);
        if (resp.code === "PAID") {
          this.setState({
            wasPaid: true,
            hideOrder: false,
          });
        } else {
          // Cualquier otro codigo de error (NOCOMPANY, NOORDER, ERRDESC, etc.)
          // cae aca. Sin este fallback, un codigo no contemplado explicitamente
          // dejaba hideOrder en true y el spinner de "Buscando tu reserva"
          // quedaba pegado para siempre.
          this.setState({
            errorMessage:
              resp.message ||
              "No pudimos encontrar tu reserva. Verifica el número e intenta nuevamente.",
            hideOrder: false,
          });
        }
      }
    } else {
      console.log("no");
    }

    this.setState({
      loading: false,
    });
  };
  componentDidMount = async () => {
    if (!isMobile()) {
      const pos = 125;
      let time = 500;
      var currentPos = window.scrollY || window.pageYOffset;
      var start = null;
      time = time || 500;

      function animation(currentTime) {
        if (!start) start = currentTime;
        var progress = currentTime - start;
        var newPos = Math.min(
          (progress / time) * (pos - currentPos) + currentPos,
          pos
        );
        window.scrollTo(0, newPos);
        if (progress < time) {
          window.requestAnimationFrame(animation);
        }
      }

      window.requestAnimationFrame(animation);
    }

    const { company_code, order_id } = this.props;

    this.setState({ company_code: company_code });

    if (order_id) {
      this.setState({ order_id: order_id });
    } else {
      console.log("no");
    }
    if (company_code && order_id) {
      console.log("check");
      this.setState({ hideOrder: true });

      setTimeout(
        async function () {
          await this.validateOrder();
        }.bind(this),
        10
      );
    } else {
      this.setState({
        loading: false,
      });
    }
  };

  renderRedirect = () => {
    if (this.state.redirect && this.state.order_id.length >= 5) {
      console.log("go");
      return (
        <Navigate
          to={
            this.state.qr_id !== ""
              ? "/api/v1/request/" +
                this.state.company_code +
                "/" +
                this.state.qr_id
              : "/api/v1/generate-request/" + this.state.company_code
          }
        />
      );
    }
  };

  render() {
    return (
      <>
        {this.renderRedirect()}

        {this.state.wasPaid ? (
          <>
            <TopBar subtitle="Confirmación de pago" />
            <div className="xp-page">
              {!this.state.loading && (
                <div className="xp-card">
                  <div className="xp-badge xp-badge-success">
                    <i className="fas fa-check"></i>
                  </div>
                  <h2>Esta reserva ya fue pagada</h2>
                  <p className="xp-sub">
                    Su pago fue procesado correctamente. No es necesario
                    realizar ningún pago adicional.
                  </p>
                  <div className="xp-summary">
                    <div className="xp-summary-row">
                      <span>Nro. de reserva</span>
                      <b>{this.state.order_id}</b>
                    </div>
                  </div>
                  {this.state.image_path && this.state.image_path !== "" && (
                    <div style={{ textAlign: "center" }}>
                      <img
                        className="image-logo"
                        src={this.state.image_path}
                      />
                    </div>
                  )}
                  <a
                    className="xp-btn-ghost"
                    href="#"
                    onClick={() => {
                      this.setState({ wasPaid: false });
                    }}
                  >
                    <i className="fas fa-search"></i> Buscar otra reserva
                  </a>
                  <div className="xp-trust">
                    <i className="fas fa-lock"></i> Pago seguro · Transacción
                    protegida
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <TopBar />
            <div className="xp-page">
              <div className="xp-card">
                <div className="xp-badge xp-badge-neutral">
                  <i className="fas fa-concierge-bell"></i>
                </div>
                {!this.state.hideOrder ? (
                  <>
                    <h2>Paga tu reserva</h2>
                    <p className="xp-sub">
                      Ingresa el número de reserva que recibiste en tu correo
                      de confirmación para continuar con el pago.
                    </p>
                    <div className="xp-search">
                      <label htmlFor="order_id">Número de reserva</label>
                      <input
                        type="text"
                        id="order_id"
                        name="order_id"
                        placeholder="Ej. 12345"
                        autoComplete="off"
                        onKeyPress={this.redirectToLogin}
                        onChange={this.changeHandler}
                        value={this.state.order_id}
                      />
                      <button
                        type="submit"
                        className="xp-btn"
                        onClick={this.redirectToLoginB}
                      >
                        <i className="fas fa-search"></i> Buscar reserva
                      </button>
                      <p className="xp-form-error">
                        {this.state.errorMessage}
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <h2>Buscando tu reserva</h2>
                    <p className="xp-loading-msg">
                      Estamos recuperando los datos de tu orden, espera un
                      momento…
                    </p>
                    <div className="contenedor-loader">
                      <MDBSpinner
                        grow
                        color="danger"
                        style={{
                          width: "2rem",
                          height: "2rem",
                          marginLeft: "1rem",
                        }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </MDBSpinner>
                      <MDBSpinner
                        grow
                        color="warning"
                        style={{
                          width: "2rem",
                          height: "2rem",
                          marginLeft: "1rem",
                        }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </MDBSpinner>
                      <MDBSpinner
                        grow
                        color="success"
                        style={{
                          width: "2rem",
                          height: "2rem",
                          marginLeft: "1rem",
                        }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </MDBSpinner>
                    </div>
                  </>
                )}
                <div className="xp-trust">
                  <i className="fas fa-lock"></i> Pago seguro · Transacción
                  protegida
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}
export default Home;
